import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.function.name";
import _objectSpread from "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2";
import "core-js/modules/es7.array.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import company from '@/views/layout/company.vue';
import { getLoginUser } from '@data/login';
import { queryClientInfo } from '@data/setting';
import { title } from '@/config/index';
import { mapActions, mapState } from 'vuex';
import { getAppList as _getAppList } from '@data/user';
export default {
  name: 'app-header',
  props: ['logoUrl'],
  components: {
    company: company
  },
  data: function data() {
    return {
      userName: '',
      userIcon: '',
      title: title,
      isWxLogin: true,
      envFlag: true,
      // 是否默认环境
      envTitle: '非学科综合测评',
      // logo处文字
      clientName: '',
      isInChoose: false,
      bmsAppLen: this.tools.getLocalStorage('bmsAppLen')
    };
  },
  created: function created() {
    this.bmsAppLen = this.tools.getLocalStorage('bmsAppLen');
  },
  mounted: function mounted() {
    if (this.getQueryString('appid') != null && this.getQueryString('code') != null) {
      this.isWxLogin = false;
    }

    if (this.$route.query.origin == 'zn') {
      this.getClientInfo();
    }

    this.getUserInfo();
    this.getAppList();
  },
  watch: {
    $route: {
      handler: function handler(val) {
        this.isInChoose = val.path === '/choose';
      },
      immediate: true
    }
  },
  computed: {
    hrefType: function hrefType() {
      return this.$route.fullPath;
    },
    needCompany: function needCompany() {
      var notNeedCompany = ['/login', '/login/', '/choose', '/updatePwd', '/infoMaintain', '/phoneRetrieval', '/certificateRetrieval', '/retrieval', '/improveInfo'];
      return !notNeedCompany.includes(this.$route.path);
    },
    needMenu: function needMenu() {
      var notNeedCompany = ['/login', '/login/'];
      return !notNeedCompany.includes(this.$route.path);
    }
  },
  methods: _objectSpread({}, mapActions('user', ['setUserVo']), {
    getAppList: function getAppList() {
      var _this = this;

      _getAppList().then(function (res) {
        _this.bmsAppLen = res.length;

        _this.tools.setLocalStorage('bmsAppLen', res.length);
      }).catch(function (err) {
        console.log(err);
      });
    },
    // 设置当前登录的角色到session
    setUserRole: function setUserRole(data) {
      this.tools.removeLocalStorage('userRole');
      var orgList = null;

      if (data.appList && data.appList.length > 0) {
        orgList = data.appList.filter(function (el) {
          return el.appCode == 'bms';
        })[0] && data.appList.filter(function (el) {
          return el.appCode == 'bms';
        })[0].orgList.filter(function (ele) {
          return ele.flag;
        })[0];
      }

      if (orgList) {
        var roleVo = orgList.list.filter(function (ele) {
          return ele.roleType == data.type;
        })[0];
        roleVo.orgCode = orgList.orgCode;
        roleVo.orgName = orgList.orgName;
        roleVo.orgType = orgList.orgType;
        this.tools.setLocalStorage('userRole', roleVo);
      }
    },
    getUserInfo: function getUserInfo() {
      var _this2 = this;

      getLoginUser().then(function (resp) {
        // note: appList包含sycp跳转到/choose
        if (resp && resp.appList && resp.appList.length > 0) {
          for (var i = 0; i < resp.appList.length; i++) {
            var item = resp.appList[i];

            if (item.appCode.toLowerCase() === 'sycp') {// this.$router.replace({ path: '/choose' });
            }
          }
        }

        _this2.setUserVo(resp);

        _this2.setUserRole(resp);

        _this2.userName = resp.name || resp.account;
        _this2.userIcon = resp.profilePictureCompressUrl || resp.profilePictureUrl;
      }).catch(function (err) {
        console.log(err);
      });
    },

    /* 查询网站信息 */
    getClientInfo: function getClientInfo() {
      var _this3 = this;

      queryClientInfo({
        clientId: 'ceping'
      }).then(function (res) {
        if (res.code == '200') {
          _this3.clientName = res.payload.clientName;
          localStorage.setItem('siteInfo', JSON.stringify(res.payload));
          document.title = res.payload.clientName;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    // 关闭当前浏览器tab
    closeWP: function closeWP() {
      var Browser = navigator.appName;
      var indexB = Browser.indexOf('Explorer');

      if (indexB > 0) {
        var indexV = navigator.userAgent.indexOf('MSIE') + 5;
        var Version = navigator.userAgent.substring(indexV, indexV + 1);

        if (Version >= 7) {
          window.open('', '_self', '');
          window.close();
        } else if (Version == 6) {
          window.opener = null;
          window.close();
        } else {
          window.opener = '';
          window.close();
        }
      } else {
        window.close();
      }
    },
    // 获取url参数
    getQueryString: function getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    logout: function logout() {
      if (this.getQueryString('appid') != null && this.getQueryString('code') != null) {
        this.closeWP();
      } else if (window.sessionStorage.getItem('origin') == 'dx') {
        this.tools.removeLocalStorage('userInfo');
        window.sessionStorage.removeItem('origin');
        window.location.href = process.env.VUE_APP_DX_URL;
      } else {
        this.$router.push('/logout');
        this.tools.removeSessionStorage('loginIndex');
      }
    },
    toUserCenterPage: function toUserCenterPage() {
      this.$router.push({
        path: '/userCenter'
      });
    },
    toHelpPage: function toHelpPage() {
      this.$router.push({
        path: '/userHelp'
      });
    },
    toHomePage: function toHomePage() {
      if (this.hrefType.indexOf('userCenter') !== -1) {
        var userInfo = window.localStorage.getItem('userInfo');

        if (undefined !== userInfo && null !== userInfo && '' !== userInfo) {
          this.$router.push({
            path: '/setting'
          });
        } else {
          this.$router.push({
            path: '/login'
          });
        }
      }
    },
    goHome: function goHome() {
      this.$router.push({
        path: '/choose'
      });
    }
  })
};